export default __webpack_public_path__ + "static/eventDriven2-39e9a86feb3c820d913944bd380e3ad5.svg";